module.exports = __webpack_public_path__ + "img/dark-mud-decal-22.0ff13c98.png";